const STORAGE_KEY = "adatis.clients.listFilters.v1";

export const CLIENT_LIST_FILTER_PARAM_KEYS = [
  "has_active_credits",
  "has_active_club",
  "has_active_protocol",
  "credits_expiring_within_days",
  "has_health_records",
  "tag_id",
  "incomplete_profile",
  "missing_birth_date",
  "missing_instagram",
  "missing_acquisition_source",
  "online_booking_blocked",
] as const;

export type ClientListFilterSnapshot = {
  has_active_credits?: "1";
  has_active_club?: "1";
  has_active_protocol?: "1";
  credits_expiring_within_days?: string;
  has_health_records?: "0" | "1";
  tag_id?: string;
  incomplete_profile?: "1";
  missing_birth_date?: "1";
  missing_instagram?: "1";
  missing_acquisition_source?: "1";
  online_booking_blocked?: "1";
};

export function urlHasClientListFilters(params: URLSearchParams): boolean {
  return CLIENT_LIST_FILTER_PARAM_KEYS.some((key) => params.has(key));
}

export function readClientListFiltersFromUrl(
  params: URLSearchParams
): ClientListFilterSnapshot {
  const snapshot: ClientListFilterSnapshot = {};

  CLIENT_LIST_FILTER_PARAM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value != null && value !== "") {
      (snapshot as Record<string, string>)[key] = value;
    }
  });

  return snapshot;
}

export function applyClientListFiltersToUrl(
  params: URLSearchParams,
  snapshot: ClientListFilterSnapshot
): void {
  CLIENT_LIST_FILTER_PARAM_KEYS.forEach((key) => params.delete(key));
  Object.entries(snapshot).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.set(key, value);
    }
  });
}

export function loadStoredClientListFilters(): ClientListFilterSnapshot | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as ClientListFilterSnapshot;
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveStoredClientListFilters(
  snapshot: ClientListFilterSnapshot
): void {
  try {
    if (Object.keys(snapshot).length === 0) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    // ignore quota / private mode
  }
}
